import { FiBriefcase, FiCalendar, FiMapPin } from "react-icons/fi";

import TopicPill from "../components/ui/TopicPill";
import { experiences } from "../data/experience";

const Stack = ({ items }) => (
  <div className="exp-stack">
    {items.map((s) => (
      <TopicPill key={s} name={s} size="sm" colorIcon />
    ))}
  </div>
);

const Bullets = ({ items }) => (
  <ul className="exp-bullets">
    {items.map((b) => (
      <li key={b}>{b}</li>
    ))}
  </ul>
);

const Experience = () => {
  return (
    <div className="page experience-page">
      <div className="page-head">
        <h1 className="page-title">
          Experience <span className="page-title-alt">/ Career</span>
        </h1>
        <span className="page-sub">
          {experiences.length} roles · full-stack &amp; GenAI engineering
        </span>
      </div>

      <div className="experience-timeline">
        {experiences.map((exp) => (
          <article key={`${exp.company}-${exp.role}`} className="exp-entry lc-card">
            <span className="exp-dot" aria-hidden="true" />
            <header className="exp-head">
              <span className="exp-icon">
                <FiBriefcase />
              </span>
              <div className="exp-head-main">
                <h2 className="exp-role">{exp.role}</h2>
                <div className="exp-company">
                  {exp.company}
                  {exp.current && (
                    <span className="exp-badge-current">Current</span>
                  )}
                </div>
              </div>
              <div className="exp-head-meta">
                <span className="exp-period">
                  <FiCalendar /> {exp.period}
                </span>
                {exp.location && (
                  <span className="exp-location">
                    <FiMapPin /> {exp.location}
                  </span>
                )}
              </div>
            </header>

            {exp.tracks ? (
              <div className="exp-tracks">
                {exp.tracks.map((t) => (
                  <div key={t.name} className="exp-track">
                    <div className="exp-track-head">
                      <span className="exp-track-name">{t.name}</span>
                      <span className="exp-track-period">{t.period}</span>
                    </div>
                    <Stack items={t.stack} />
                    <Bullets items={t.bullets} />
                  </div>
                ))}
              </div>
            ) : (
              <>
                {exp.stack && <Stack items={exp.stack} />}
                {exp.bullets && <Bullets items={exp.bullets} />}
              </>
            )}
          </article>
        ))}
      </div>
    </div>
  );
};

export default Experience;
